/**
 * 会计格式化：千分位 + 2 位小数 + 货币符号 + 负号前置。
 *
 * 支持的 ISO 4217 代码：USD / CNY / EUR / GBP / JPY / HKD / SGD
 * 未知代码回退到 USD（浏览器 Intl.NumberFormat 支持全部 ISO 4217，这里是业务白名单）。
 *
 * 示例：
 *   formatMoney(1234.5)           → '$1,234.50'
 *   formatMoney(-3_000_000)       → '-$3,000,000.00'
 *   formatMoney(1234, 'CNY')      → '¥1,234.00'
 *   formatMoney(null)             → ''
 */
export const CURRENCY_OPTIONS = [
  { value: 'USD', label: 'USD - $ 美元' },
  { value: 'CNY', label: 'CNY - ¥ 人民币' },
  { value: 'EUR', label: 'EUR - € 欧元' },
  { value: 'GBP', label: 'GBP - £ 英镑' },
  { value: 'JPY', label: 'JPY - ¥ 日元' },
  { value: 'HKD', label: 'HKD - HK$ 港币' },
  { value: 'SGD', label: 'SGD - S$ 新加坡元' },
] as const;

export const DEFAULT_CURRENCY = 'USD';

const SUPPORTED: ReadonlySet<string> = new Set(CURRENCY_OPTIONS.map((c) => c.value));

export function formatMoney(
  value: number | string | null | undefined,
  currency: string | null | undefined = DEFAULT_CURRENCY,
): string {
  if (value == null || value === '') return '';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '';

  const code = currency && SUPPORTED.has(currency) ? currency : DEFAULT_CURRENCY;
  // Intl.NumberFormat 在部分 TS lib 版本里把 currency narrow 为 literal union；运行时接受任意 ISO 4217 字符串。
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    currency: code as any,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}
